import React from "react";
import { EditableField } from "./editable-field";
import { AddressCreate } from "../types/address.types";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface AddressFormProps {
  addresses: AddressCreate[];
  onChange: (e: React.ChangeEvent<HTMLElement>, index: number) => void;
  onRemove?: (index: number) => void;
  showRemoveButton?: boolean; 
}

export const AddressForm: React.FC<AddressFormProps> = ({
  addresses,
  onChange,
  onRemove,
  showRemoveButton = false,
}) => {
  return (
    <>
      {addresses.map((address, index) => (
        <div key={index} className="space-y-4 border-t pt-4 relative mb-4">
          <EditableField
            label="País"
            value={address.country}
            onChange={(e) => onChange(e, index)}
            required
            type="text"
            id={`country-${index}`}
            name="country"
            placeholder="Ingrese su país"
            minLength={3}
            maxLength={100}
          />
          <EditableField
            label="Provincia"
            value={address.state}
            onChange={(e) => onChange(e, index)}
            required
            type="text"
            id={`state-${index}`}
            name="state"
            placeholder="Ingrese su provincia"
            minLength={3}
            maxLength={100}
          />
          <EditableField
            label="Ciudad"
            value={address.city}
            onChange={(e) => onChange(e, index)}
            required
            type="text"
            id={`city-${index}`}
            name="city"
            placeholder="Ingrese su ciudad"
            minLength={3}
            maxLength={100}
          />
          <EditableField
            label="Dirección"
            value={address.address_line}
            onChange={(e) => onChange(e, index)}
            required
            type="text"
            id={`address_line-${index}`}
            name="address_line"
            placeholder="Ingrese su dirección"
            minLength={3}
            maxLength={100}
          />
          {showRemoveButton && onRemove && (
            <div className="flex justify-end mt-2">
              <button
                onClick={() => onRemove(index)}
                type="button"
                className="flex items-center px-3 py-2 bg-red-500 text-white font-semibold rounded hover:bg-red-600 transition"
              >
                <XMarkIcon className="w-4 h-4 mr-1" />
                Eliminar
              </button>
            </div>
          )}
        </div>
      ))}
    </>
  );
};
